import { Http } from "../Http";
import { LocationDto } from "../../../Api/Model/LocationDto.csharp";

export interface ILocationsApi {
  get(): Promise<LocationDto[]>;
}

export class LocationsApi implements ILocationsApi {
  public get = (): Promise<LocationDto[]> => {
    return Http.get(`/api/locations`, null) as Promise<LocationDto[]>;
  };
}
